"use client"
import styled from "@emotion/styled"
import { HomeIcon, RedirectLinkIcon } from "ui/icons"

import type { Article } from "lib/articles"
import { Sitemap as SitemapType } from "lib/utils"
import colors from "theme/colors"
import { Container, CustomBreadcrumbs, LinkComponent, NewText } from "ui"
import { getNonUmbracoURL } from "utils/utils"

const StyledSitemapDiv = styled.div`
  margin-top: 10px;
  padding-bottom: 40px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-bottom: 90px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding-bottom: 190px;
  }
`

const StyledLinksWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  padding-top: 20px;
  row-gap: 20px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 40px;
    grid-template-columns: 1fr 1fr;
    column-gap: 80px;
    padding-left: 30px;
  }
`

type Props = {
  pages: SitemapType
  articles?: Article[]
}

const footer = [
  "price-lists",
  "accessibility",
  "termsclub",
  "privacy-policy",
  "terms",
]

function SitemapChargePage({ pages, articles = [] }: Props) {


  const mainPages = pages.filter(
    (page) => !footer.some((footerItem) => page.url.includes(footerItem)),
  )
  return (

    <Container>
      <CustomBreadcrumbs
        current={{ title: "מפת אתר", url: `/` }}
        parents={[{ title: <HomeIcon />, url: "/" }]}
      />

      <StyledSitemapDiv>
        <NewText
          component={"h2"}
          largeDesktopFontSize={48}
          largeDesktopLineHeight="50px"
          desktopFontSize={48}
          desktopLineHeight={"50px"}
          mobileFontSize={28}
          mobileLineHeight={"32px"}
          desktopFontWeight={500}
          color={colors.black}
        >
          מפת אתר
        </NewText>
        <StyledLinksWrapper>
          {mainPages.map((page, index) => {
            return (
              <LinkComponent
                key={index}
                text={page.title || ""}
                link={page.url || ""}
                largeDesktopFontSize={24}
                largeDesktopLineHeight="28px"
                mobileFontSize={18}
                mobileLineHeight={"20px"}
                fontSize={24}
                desktopLineHeight="28px"
                icon={<RedirectLinkIcon color={colors.blue} />}
                fontWeight={500}
              />
            )
          })}
        </StyledLinksWrapper>
        {articles.length > 0 && (
          <>
            <NewText
              component={"h3"}
              largeDesktopFontSize={32}
              largeDesktopLineHeight="36px"
              desktopFontSize={32}
              desktopLineHeight={"36px"}
              mobileFontSize={22}
              mobileLineHeight={"26px"}
              desktopFontWeight={500}
              color={colors.black}
              style={{ paddingTop: 40 }}
            >
              מידע שימושי
            </NewText>
            <StyledLinksWrapper>
              {articles.map((article, index) => (
                <LinkComponent
                  key={index}
                  text={article.name || ""}
                  link={getNonUmbracoURL(article.url) || ""}
                  largeDesktopFontSize={24}
                  largeDesktopLineHeight="28px"
                  mobileFontSize={18}
                  mobileLineHeight={"20px"}
                  fontSize={24}
                  desktopLineHeight="28px"
                  icon={<RedirectLinkIcon color={colors.blue} />}
                  fontWeight={500}
                />
              ))}
            </StyledLinksWrapper>
          </>
        )}
      </StyledSitemapDiv>
    </Container>
  )
}

export default SitemapChargePage
